const BasicTheme = {
    hiddenLabel: false
}

export default BasicTheme;